import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Guid, TermSheetFacilityFee } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useTermSheetFacilityFeesQuery(
	dataRoomGuid?: Guid | undefined,
	termSheetGuid?: Guid | null | undefined,
	revisionGuid?: Guid | null | undefined,
	facilityGuid?: Guid | null | undefined,
	options?:
		| Omit<UseQueryOptions<TermSheetFacilityFee[], unknown, TermSheetFacilityFee[], any>, 'queryKey' | 'queryFn'>
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.TermSheets.FacilityFees(dataRoomGuid, termSheetGuid, revisionGuid, facilityGuid),
		() =>
			AxiosUtils.getResponseData<TermSheetFacilityFee[]>(
				api.get(
					CerebroApiEndpoints.TermSheets.FacilityFees(dataRoomGuid, termSheetGuid, revisionGuid, facilityGuid)
				)
			),
		options
	);
}
